<span id="container" *ngIf="gefAuditList && gefAuditList.length > 0 && this.auth2Svc.hasFeature(this.auth2Svc.utilisateur, HAS_GEF);">

<label
  [title]="isValidationRequired() ? 'Une action est requise' : 'Synchronisé avec la GEF'"
  [class]="isValidationRequired() ? 'badge cursor badge-gef-warn' : 'badge cursor badge-gef'"
  (click)="openGefAuditDialog($event)">
        <span class="fa-layers fa-fw">
          <i *ngIf="isValidationRequired()" class="fas fa-exclamation-triangle mg-r-5"></i>
          <i *ngIf="!isValidationRequired()" class="fas fa-money-bill-transfer mg-r-5"></i>
          <span class="fa-layers-counter">GEF</span>
        </span>
  </label>
</span>
